export enum NotificationType {
  ImpersonationActive = 'ImpersonationActive',
}